import ForgotPassword from './ForgotPassword.vue';
import store from '@/store';
import authentication from '@/authentication';

const routes = [
  {
    path      : '/forgot-password/:userId([^/]*)?',
    name      : 'ForgotPassword',
    component : ForgotPassword,
    meta      : {
      isPublic: true
    },
    beforeEnter(to, from, next) {
      let actions = [];

      if(to.params.userId) {
        actions.push(store.dispatch(`${authentication.store.namespace}/setUserId`, to.params.userId));
      }

      Promise.all(actions).then(next).catch(next);
    }
  }
];

export default routes;
